import React from "react"
import PropTypes from "prop-types"
import Modal from "../Modal"
import "react-intl-tel-input/dist/libphonenumber.js"
import "react-intl-tel-input/dist/main.css"
import BusinessEnquiry from "../BusinessEnquiry"
import "./enquiry.css"

export class BusinessEnquiryForm extends React.Component {
	render () {
		const { show, onHide } = this.props
		return (
			<Modal direction="" className="businessEnq__wrapper" show={show} onHide={onHide}>
				<Modal.Header>
					<span className="cross pull-right">
						<i onClick={onHide} className="fa fa-times" />
					</span>
				</Modal.Header>
				<Modal.Body>
					<BusinessEnquiry onHide={onHide} title="Business Enquiry Form" />
				</Modal.Body>
				<Modal.Footer />
			</Modal>
		)
	}
}

BusinessEnquiryForm.propTypes = {
	show: PropTypes.bool,
	onHide: PropTypes.func,
}

export default BusinessEnquiryForm



// WEBPACK FOOTER //
// ./src/components/BusinessEnquiryForm/index.js